<h2 mat-dialog-title>{{'shareInspection.exportInspection' | translate }}</h2>

<mat-dialog-content class="content">
  <form [formGroup]="form">
    <div>
      <label for="expiration-date">{{"shareInspection.expirationDate" | translate}}</label>
      <evc-input
      id="expiration-date"
      formControlName="expirationDate"
      type="date"
      />
    </div>
    <div formArrayName="emails" class="emails">
      <label for="expiration-date">{{"shareInspection.emails" | translate}}</label>
      <div *ngFor="let emailControl of emails.controls; index as i" class="email-control">
        <evc-input class="email-input" [formControlName]="i" type="email" [placeholder]="'shareInspection.emailPlaceholder' | translate"/>
        <evc-nav-button type="icon" (click)="removeEmail(i)" size="sm">
          <evc-svg-icon icon="trash-can" size="sm" class="remove-icon"></evc-svg-icon>
        </evc-nav-button>
      </div>
    </div>
    <evc-nav-button type="secondary" (click)="addEmail()" class="add-email-button">{{ "shareInspection.addEmail" | translate }}</evc-nav-button>
  </form>
</mat-dialog-content>

<mat-dialog-actions class="footer">
  <evc-nav-button type="secondary" mat-dialog-close>{{ "shareInspection.cancel" | translate }}</evc-nav-button>
  <evc-nav-button (click)="shareInspectionFolder()" [disabled]="!form.valid">{{ "shareInspection.share" | translate }}</evc-nav-button>
</mat-dialog-actions>

